/**
 * Tour config — DEVELOPMENT.
 *
 * Anything not listed here is OFF (false by default). Edit a tour's entry to control
 * it in this environment. See ../README.md.
 */

import type { TourConfig } from './types';

export const config: TourConfig = {
  announcements: {
    enabled: true,
    autoStart: true,
    startDate: null,
    endDate: null
  }
};
